import { render, staticRenderFns } from "./BestaetigenLieferung.vue?vue&type=template&id=3ab4fd9d"
import script from "./BestaetigenLieferung.vue?vue&type=script&lang=ts"
export * from "./BestaetigenLieferung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports